<template>
    <div class="col-xl-6 col-sm-6">

        <div class="card shadow-md">
            <div class="card-body p-0">
                <div class="d-flex">
                    <div>
                        <img
                        :src="event.eventImageSrc"
                        alt="Event Image"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        class="border-end img-fluid border-0 rounded-start img-cover"
                        />
                    </div>

                    <div class="d-flex flex-column w-100">
                        <div class="p-3">
                            <h5 class="mb-0 text-truncate">
                                <b-link
                                    @click="() => this.$emit('view', event)"
                                    class="text-primary font-size-14 fw-bold"
                                >
                                    {{event.name | truncator(20,'...')}}
                                </b-link>
                            </h5>
                             <p class="small">{{event.description | truncator(200,'...')}}</p>

                            <div class="mb-0 text-dark small fw-bold">Attendee: <span class="ms-1">{{event.attendee}}</span></div>
                        </div>

                        <!-- <div class="d-flex btn-group btn-icon" role="group">
                            <div class="btn">
                                <div class="form-check form-switch">
                                <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                                <input
                                    class="form-check-input"
                                    v-model="event.status"
                                    type="checkbox"
                                    id="flexSwitchCheckDefault"
                                />
                            </div>
                            </div>
                        
                            <button class="btn btn-outline-light">
                                <i class="text-primary bx bx-pencil"></i> Edit
                            </button>
                            <button class="btn btn-outline-light">
                                <i class="text-danger mdi mdi-delete"></i> Delete
                            </button>
                        </div> -->

                        <div class="d-flex btn-group btn-icon border-top" role="group">
                            <div class="btn not-allowed">
                                <div class="form-check form-switch not-allowed">
                                    <label class="form-check-label not-allowed" for="flexSwitchCheckDefault">Active</label>
                                    <input
                                        class="form-check-input"
                                        v-model="event.status"
                                        type="checkbox"
                                        id="flexSwitchCheckDefault"
                                        disabled
                                    />
                                </div>
                            </div>

                            <b-link @click="() => this.$emit('edit', event)" class="btn btn-outline-light event-btn">
                                    <i class="text-primary bx bx-pencil"></i> Edit
                            </b-link>

                            <div v-if="testDelete" class="btn btn-outline-light event-btn">
                                <b-link  @click="() => this.$emit('delete', event)"> 
                                    <i class="text-danger mdi mdi-delete"></i> Delete
                                </b-link>
                            </div>
                        

                            <div v-if="!testDelete" class="btn btn-outline-light event-btn not-allowed">
                                <button style="color: #666;" disabled>
                                    <i class="text-danger mdi mdi-delete"></i> Delete
                                </button>
                            </div>
                        </div>

                        <div class="form-check form-switch not-allowed" style="display: none;">
                            <label class="form-check-label not-allowed" for="flexSwitchCheckDefault">Enabled Delete</label>
                            <input
                                class="form-check-input"
                                v-model="testDelete"
                                type="checkbox"
                                id="flexSwitchCheckDefault"
                                disabled
                            />
                        </div>
                    </div>
 
                </div>
            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->


        <div class="card shadow-none" v-if="false">
            <div class="card-body p-0">
                <div class="d-flex">
                    <div class="avatar">
                        <img
                        :src="event.eventImageSrc"
                        alt="Event Image"
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')"
                        class="img-thumbnail border-0"
                        />
                    </div>
                    <div class="flex-grow-1r align-self-center overflow-hidden">
                        <h5 class="mb-0 text-truncate">
                        <b-link
                            @click="() => this.$emit('view', event)"
                            class="text-primary font-size-14 fw-bold"
                        >
                            {{event.name | truncator(20,'...')}}</b-link
                        >
                        </h5>
                        <p class="small">{{event.description | truncator(200,'...')}}</p>
                        <div class="d-flex justify-content-between">
                            <span class="mb-0 text-dark small fw-bold">Attendee: {{event.attendee}}</span>
                        </div>
                        <div class="btn-group btn-icon" role="group">
                            <div class="form-check form-switch">
                                <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                                <input
                                    class="form-check-input"
                                    v-model="event.status"
                                    type="checkbox"
                                    id="flexSwitchCheckDefault"
                                />
                            </div>
                            <button class="btn btn-outline-light">
                                <i class="text-primary bx bx-pencil"></i> Edit
                            </button>
                            <button class="btn btn-outline-light">
                                <i class="text-danger mdi mdi-delete"></i> Delete
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4 img-container">
                        <img 
                        :src="event.eventImageSrc"
                        alt=""
                        @error="(e) => e.target.src = require('@/assets/images/img-placeholder.png')" 
                        class="img-fluid"/>
                    </div>
                    <div class="col-md-8 pt-2 pl-0">
                        <h5 class="mb-0 text-truncate">
                            <b-link
                                @click="() => this.$emit('view', event)"
                                class="text-primary font-size-14 fw-bold"
                            >
                                {{event.name | truncator(20,'...')}}</b-link
                            >
                        </h5>
                        <p class="small" style="height: 33%; overflow: scroll;">{{event.description | truncator(150,'...')}}</p>
                        <div class="d-flex justify-content-between">
                            <span class="mb-0 text-dark small fw-bold">Attendee: {{event.attendee}}</span>
                        </div>
                        <table class="table table-bordered mb-0">
                            <tr>
                                <td class="not-allowed">
                                    <div class="form-check form-switch not-allowed" style="padding-left:40px;">
                                        <label class="form-check-label not-allowed" for="flexSwitchCheckDefault">Active</label>
                                        <input
                                            class="form-check-input"
                                            v-model="event.status"
                                            type="checkbox"
                                            id="flexSwitchCheckDefault"
                                            disabled
                                        />
                                    </div>
                                </td>
                                <td>
                                    <b-link @click="() => this.$emit('edit', event)" class="btn btn-outline-light event-btn">
                                        <i class="text-primary bx bx-pencil"></i> Edit
                                    </b-link>
                                </td>
                                <td v-if="testDelete">
                                    <b-link @click="() => this.$emit('delete', event)" class="btn btn-outline-light event-btn">
                                        <i class="text-danger mdi mdi-delete"></i> Delete
                                    </b-link>
                                </td>
                                <td v-if="!testDelete" class="not-allowed">
                                    <button class="btn btn-outline-light event-btn" style="color: #666;" disabled>
                                        <i class="text-danger mdi mdi-delete"></i> Delete
                                    </button>
                                </td>
                            </tr>
                        </table>
                        
                        <div class="form-check form-switch not-allowed" style="display: none;">
                            <label class="form-check-label not-allowed" for="flexSwitchCheckDefault">Enabled Delete</label>
                            <input
                                class="form-check-input"
                                v-model="testDelete"
                                type="checkbox"
                                id="flexSwitchCheckDefault"
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!-- end card body -->
        </div>
        <!-- end card -->
    </div>
    <!-- end col -->

  
</template>
<style>
 .event-btn {
    width: 100%;
    border-top: 0px;
    border-bottom: 0px;
    border-right: 0px;
 }
 .pl-0{padding-left: 0px;}
 .not-allowed{cursor:not-allowed;}
 .img-container{    
    height: 165px;
    overflow: hidden;
 }

 .img-cover {
  object-fit: cover;
  width: 200px;
  height: 150px;
}
</style>
<script>
export default {
    props: ['event'],
    data() {
        return {
            testDelete: true
        }
    }
}
</script>